import React from 'react';
import Typography from '../Typography';
import Button from '../Button';
import { StyledAlert } from './components/AlertStyles';
import { useAlert } from './hooks/useAlert';

const Alert = ({ variant = 'info', message, actionLabel, onActionClick, ...props }) => {
  const { handleActionClick } = useAlert({ onActionClick });

  return (
    <StyledAlert variant={variant} {...props}>
      <Typography variant="paragraph" style={{ color: '#ffffff', fontWeight: 600, margin: 0 }}>
        {message}
      </Typography>
      {actionLabel && onActionClick && (
        <Button
          variant="secondary"
          onClick={handleActionClick}
          style={{
            borderRadius: '50px',
            padding: '6px 16px',
            fontSize: '0.85rem',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderColor: 'transparent',
            color: '#ffffff',
          }}
        >
          {actionLabel}
        </Button>
      )}
    </StyledAlert>
  );
};

export default Alert;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Alert/Alert.jsx